/*
 * @Author: 黄智强
 * @Date: 2018-42-23 10:04:29
 * @Last Modified by: 陈航
 * @Last Modified time: 2019-01-04 16:50:54
 * @说明：财务管理 接口
 */
// 获取用户余额信息
export const pocketGetUserAccount = '/pocket/get-user-account'
// 充值
export const pocketDeposit = '/pocket/deposit'
// 获取卡包列表
export const pocketGetUserCardList = '/pocket/get-user-card-list'
// 获取活动卡券类型
export const pocketGetActivityType = '/pocket/get-activity-type'
// 获取活动卡券状态
export const pocketGetActivityStatus = '/pocket/get-activity-status'
// 获取充值活动信息
export const pocketDepositActivity = '/pocket/deposit-activity'
// 获取账户信息
export const pocketGetAccountInfo = '/pocket/get-account-info'
// 提现
export const pocketWithdraw = '/pocket/withdraw'
// 获取提现记录
export const pocketGetWithdrawRecord = '/pocket/get-withdraw-record'
// 获取提现状态列表
export const pocketGetWithdrawStep = '/pocket/get-withdraw-step'
// 获取会员可使用优惠券
export const pocketCouponList = '/pocket/coupon-list'
